type TitleProps = {
    title : string
}

const TitleAboutChatbot = ({title} : TitleProps) => {
  return (
    <h4 className="text-subColor5 text-[25px]">{title}</h4>
  )
}

export default TitleAboutChatbot